import React, { useState, useEffect, useRef } from 'react';

const VendorPageStyles = () => (
  <style>{`
    :root { scroll-behavior: smooth; }
    body { font-family: 'Inter', sans-serif; background-color: #050505; color: #e5e7eb; line-height: 1.6; overflow-x: hidden; }
    @keyframes fadeInUp { from { opacity: 0; transform: translateY(30px); } to { opacity: 1; transform: translateY(0); } }
    .animate-visible { animation: fadeInUp 0.6s cubic-bezier(0.2, 0.8, 0.2, 1) forwards; }
    .hero-bg { background-color: #050505; background-image: radial-gradient(circle at 15% 50%, rgba(56, 189, 248, 0.08) 0%, transparent 40%), radial-gradient(circle at 85% 30%, rgba(129, 140, 248, 0.08) 0%, transparent 40%), linear-gradient(#0a0a0a 1px, transparent 1px), linear-gradient(90deg, #0a0a0a 1px, transparent 1px); background-size: 100% 100%, 100% 100%, 40px 40px, 40px 40px; }
    .btn-primary { background: linear-gradient(135deg, #0ea5e9, #4f46e5); position: relative; overflow: hidden; transition: all 0.3s ease; box-shadow: 0 4px 20px rgba(14, 165, 233, 0.3); }
    .btn-primary:hover:not(:disabled) { transform: translateY(-2px); box-shadow: 0 8px 30px rgba(14, 165, 233, 0.5); }
    .btn-primary:disabled { opacity: 0.6; cursor: not-allowed; box-shadow: none; }
    .feature-card { background: linear-gradient(180deg, rgba(30, 41, 59, 0.4), rgba(15, 23, 42, 0.6)); border: 1px solid rgba(255, 255, 255, 0.05); backdrop-filter: blur(12px); transition: all 0.3s ease; }
    .feature-card.active { border-color: rgba(56, 189, 248, 0.5); background: linear-gradient(180deg, rgba(14, 165, 233, 0.1), rgba(15, 23, 42, 0.8)); }
    .feature-card:hover:not(.active) { border-color: rgba(255, 255, 255, 0.15); }
    .cyber-input { background: rgba(15, 23, 42, 0.6); border: 1px solid rgba(255, 255, 255, 0.1); color: #fff; transition: all 0.3s ease; }
    .cyber-input:focus { outline: none; border-color: #38bdf8; box-shadow: 0 0 0 3px rgba(56, 189, 248, 0.15); background: rgba(15, 23, 42, 0.9); }
    .cyber-input::placeholder { color: #4b5563; }
    .modal-backdrop { background: rgba(0, 0, 0, 0.7); backdrop-filter: blur(8px); }
    .modal-content { background: #0a0a0a; border: 1px solid rgba(255, 255, 255, 0.1); box-shadow: 0 25px 60px rgba(0,0,0,0.5), 0 0 0 1px rgba(255,255,255,0.05); }
  `}</style>
);

const Icons = {
  Wallet: () => <svg fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5"><path strokeLinecap="round" strokeLinejoin="round" d="M21 12a2.25 2.25 0 00-2.25-2.25H15a3 3 0 11-6 0H5.25A2.25 2.25 0 003 12m18 0v6a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 18v-6m18 0V9M3 12V9m18 0a2.25 2.25 0 00-2.25-2.25H5.25A2.25 2.25 0 003 9m18 0V6a2.25 2.25 0 00-2.25-2.25H5.25A2.25 2.25 0 003 6v3" /></svg>,
  Terminal: () => <svg fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6"><path strokeLinecap="round" strokeLinejoin="round" d="M8 9l3 3-3 3m5 0h3M5 20h14a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg>,
  Zap: () => <svg fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6"><path strokeLinecap="round" strokeLinejoin="round" d="M3.75 13.5l10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75z" /></svg>,
  Monitor: () => <svg fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6"><path strokeLinecap="round" strokeLinejoin="round" d="M9 17.25v1.007a3 3 0 01-.879 2.122L7.5 21h9l-.621-.621A3 3 0 0115 18.257V17.25m6-12V15a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 15V5.25m18 0A2.25 2.25 0 0018.75 3H5.25A2.25 2.25 0 003 5.25m18 0V12a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 12V5.25" /></svg>,
  Alert: () => <svg fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6"><path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" /></svg>,
  Check: () => <svg fill="none" viewBox="0 0 24 24" strokeWidth="3" stroke="currentColor" className="w-4 h-4"><path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" /></svg>,
  Success: () => <svg fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" className="w-6 h-6 text-emerald-400"><path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>,
  Users: () => <svg fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5"><path strokeLinecap="round" strokeLinejoin="round" d="M15 19.128a9.38 9.38 0 002.625.372 3.75 3.75 0 003.75-3.75 3.75 3.75 0 00-3.75-3.75 9.38 9.38 0 00-2.625.372m-6 6.756A9.38 9.38 0 016.375 19.5a3.75 3.75 0 01-3.75-3.75A3.75 3.75 0 016.375 12a9.38 9.38 0 012.625.372m0 6.756V12.372m6 6.756V12.372M12 8.25a3 3 0 100-6 3 3 0 000 6z" /></svg>,
  Chart: () => <svg fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5"><path strokeLinecap="round" strokeLinejoin="round" d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 013 19.875v-6.75zM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V8.625zM16.5 4.125C16.5 3.504 17.004 3 17.625 3h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V4.125z" /></svg>,
  Shield: () => <svg fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5"><path strokeLinecap="round" strokeLinejoin="round" d="M12 3.75l7.5 3v5.25c0 4.625-3.05 7.8-7.5 8.25-4.45-.45-7.5-3.625-7.5-8.25V6.75l7.5-3z" /></svg>,
  History: () => <svg fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5"><path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6l3.75 2.25M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
};

const API_URL = window.location.hostname === 'localhost'
  ? 'http://localhost:5000'
  : 'https://gateway.checkscript.online';

const TURNSTILE_SITE_KEY = '0x4AAAAAACogxPVIgu5ZqAFu';

const DASHBOARD_TABS = [
  { id: 'overview', label: 'Overview', icon: Icons.Chart },
  { id: 'users', label: 'My Users', icon: Icons.Users },
  { id: 'usage', label: 'Usage', icon: Icons.Terminal },
  { id: 'wallet', label: 'Wallet', icon: Icons.Wallet },
  { id: 'ledger', label: 'Ledger', icon: Icons.Wallet },
  { id: 'activity', label: 'Audit', icon: Icons.Shield },
  { id: 'history', label: 'History', icon: Icons.History },
];

const StatCard = ({ label, value, hint, tone = 'sky', children }) => {
  const tones = {
    sky: 'border-sky-500/20 bg-sky-950/20 text-sky-400',
    indigo: 'border-indigo-500/20 bg-indigo-950/20 text-indigo-400',
    violet: 'border-violet-500/20 bg-violet-950/20 text-violet-400',
    emerald: 'border-emerald-500/20 bg-emerald-950/20 text-emerald-400',
    cyan: 'border-cyan-500/20 bg-cyan-950/20 text-cyan-400',
    amber: 'border-amber-500/20 bg-amber-950/20 text-amber-400',
    red: 'border-red-500/20 bg-red-950/20 text-red-400',
  };

  return (
    <div className={`rounded-xl border p-5 ${tones[tone] || tones.sky}`}>
      <p className="text-[10px] uppercase tracking-wider font-semibold text-gray-500 mb-2">{label}</p>
      <div className="flex items-end justify-between gap-3">
        <p className="text-3xl font-bold font-mono text-current leading-none">{value}</p>
        {children}
      </div>
      {hint && <p className="text-xs text-gray-400 mt-3 leading-relaxed">{hint}</p>}
    </div>
  );
};

const EmptyDashboardState = ({ icon, title, body }) => {
  const Icon = icon;
  return (
    <div className="rounded-2xl border border-white/10 bg-white/[0.03] p-8 text-center">
      <div className="w-12 h-12 rounded-xl mx-auto mb-4 bg-white/5 border border-white/10 flex items-center justify-center text-gray-400">
        <Icon />
      </div>
      <h4 className="text-white font-semibold mb-2">{title}</h4>
      <p className="text-gray-500 text-sm max-w-md mx-auto">{body}</p>
    </div>
  );
};

const PermissionRow = ({ label, enabled, detail }) => (
  <div className="flex items-center justify-between gap-4 p-4 rounded-xl bg-black/30 border border-white/5">
    <div>
      <p className="text-white font-medium">{label}</p>
      <p className="text-xs text-gray-500 mt-0.5">{detail}</p>
    </div>
    <span className={`text-[10px] px-2.5 py-1 rounded-md border font-bold uppercase tracking-wider ${enabled ? 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20' : 'bg-red-500/10 text-red-400 border-red-500/20'}`}>
      {enabled ? 'Enabled' : 'Revoked'}
    </span>
  </div>
);

const hasLpunestAccess = (user) => Array.isArray(user?.restrictions) && !user.restrictions.includes('lpunest');

const hasAnyLiveAccess = (user) => (
  user?.status === 'active'
  || user?.premium_status === 'active'
  || user?.RDP_status === 'active'
  || hasLpunestAccess(user)
);

const getUserServiceLabels = (user) => {
  const labels = [];
  if (user?.status === 'active') labels.push('Account');
  if (user?.status === 'active' && Number(user?.api_limit || 0) > 0) labels.push('Questions');
  if (user?.premium_status === 'active') labels.push('Premium');
  if (user?.RDP_status === 'active') labels.push('RDP');
  if (hasLpunestAccess(user)) labels.push('LPUNEST');
  return labels;
};

const SERVICE_LABELS = {
  account: 'Account',
  questions: 'Questions',
  premium: 'Premium',
  remote: 'RDP',
  lpunest: 'LPUNEST',
};

const getRecoverableServiceLabels = (user) => (
  Array.isArray(user?.recoverable_services) && user.recoverable_services.length
    ? user.recoverable_services
    : Array.isArray(user?.suspended_services) ? user.suspended_services : []
).map(service => SERVICE_LABELS[service] || service).filter(Boolean);

const ACTION_LABELS = {
  ACTIVATION: 'Activation',
  TOP_UP: 'Top-up',
  SUSPEND: 'Suspend',
  REACTIVATE: 'Reactivate',
  WALLET_DEBIT: 'Wallet debit',
  WALLET_CREDIT: 'Wallet credit',
  DASHBOARD_VIEW: 'Dashboard',
  TELEGRAM_COMMAND: 'Telegram',
};

const getActionTone = (action) => {
  if (action === 'SUSPEND') return 'bg-red-500/10 text-red-300 border-red-500/25';
  if (action === 'REACTIVATE') return 'bg-emerald-500/10 text-emerald-300 border-emerald-500/25';
  if (action === 'TOP_UP' || action === 'ACTIVATION') return 'bg-sky-500/10 text-sky-300 border-sky-500/25';
  if (action === 'TELEGRAM_COMMAND') return 'bg-violet-500/10 text-violet-300 border-violet-500/25';
  return 'bg-white/5 text-gray-300 border-white/10';
};

const formatDashboardDate = (value) => {
  if (!value) return 'N/A';
  return new Date(value).toLocaleString();
};

const formatLedgerDelta = (value, suffix = '') => {
  const number = Number(value || 0);
  return `${number > 0 ? '+' : ''}${number}${suffix}`;
};

const buildUsageFromUsers = (users, existingUsage = {}) => {
  const totalApiLimit = users.reduce((sum, user) => sum + Number(user.api_limit || 0), 0);
  const totalApiUsed = users.reduce((sum, user) => sum + Number(user.api_used || 0), 0);
  const now = new Date();

  return {
    ...existingUsage,
    total_users: users.length,
    active_users: users.filter(user => user.status === 'active').length,
    inactive_users: users.filter(user => user.status !== 'active').length,
    premium_users: users.filter(user => user.premium_status === 'active').length,
    remote_users: users.filter(user => user.RDP_status === 'active').length,
    remote_expired_users: users.filter(user => user.RDP_status === 'active' && user.RDP_expire && new Date(user.RDP_expire) < now).length,
    lpunest_users: users.filter(hasLpunestAccess).length,
    total_api_limit: totalApiLimit,
    total_api_used: totalApiUsed,
    remaining_api: Math.max(totalApiLimit - totalApiUsed, 0),
    api_usage_percent: totalApiLimit ? Math.round((totalApiUsed / totalApiLimit) * 100) : 0,
  };
};

const VendorActivateUser = () => {
  const [formData, setFormData] = useState({
    vendorKey: '', promoCode: '', name: '', email: '', mobile: '',
    registrationNumber: '', wantQuestions: false, questions: 0, wantPremium: false, wantRemote: false, wantLpunest: false, remoteDuration: '1d',
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [notice, setNotice] = useState(null);
  const [successData, setSuccessData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showApprovalModal, setShowApprovalModal] = useState(false);
  const [approvalMessage, setApprovalMessage] = useState('');

  // Turnstile State & Refs
  const [turnstileToken, setTurnstileToken] = useState(null);
  const turnstileRef = useRef(null);

  const [showBalanceModal, setShowBalanceModal] = useState(false);
  const [balanceKey, setBalanceKey] = useState('');
  const [balanceData, setBalanceData] = useState(null);
  const [balanceLoading, setBalanceLoading] = useState(false);
  const [balanceError, setBalanceError] = useState(null);
  const [activeDashboardTab, setActiveDashboardTab] = useState('overview');
  const [dashboardSearch, setDashboardSearch] = useState('');
  const [dashboardStatusFilter, setDashboardStatusFilter] = useState('all');
  const [dashboardServiceFilter, setDashboardServiceFilter] = useState('all');
  const [dashboardActionLoading, setDashboardActionLoading] = useState(false);
  const [dashboardActionError, setDashboardActionError] = useState(null);
  const [dashboardActionNotice, setDashboardActionNotice] = useState(null);
  const [pendingRevokeUser, setPendingRevokeUser] = useState(null);
  const [pendingReactivateUser, setPendingReactivateUser] = useState(null);
  
  const [balanceTurnstileToken, setBalanceTurnstileToken] = useState(null);
  const balanceTurnstileRef = useRef(null);

  // 1. Initial Animation & Script Load
  useEffect(() => {
    const elements = document.querySelectorAll('.animate-on-load');
    elements.forEach((el, index) => setTimeout(() => el.classList.add('animate-visible'), index * 100));

    if (!document.getElementById('cf-turnstile-script')) {
      const s = document.createElement('script');
      s.id = 'cf-turnstile-script';
      s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      s.async = true;
      document.head.appendChild(s);
    }
  }, []);

  // 2. Render Activation Modal Turnstile (Runs when review modal opens)
  useEffect(() => {
    if (!showModal || !turnstileRef.current) return;
    setTurnstileToken(null);
    let widgetId = null;

    const mount = () => {
      if (!window.turnstile || !turnstileRef.current) return;
      turnstileRef.current.innerHTML = '';
      widgetId = window.turnstile.render(turnstileRef.current, {
        sitekey: TURNSTILE_SITE_KEY,
        callback: (token) => setTurnstileToken(token),
        'expired-callback': () => setTurnstileToken(null),
        'error-callback': () => setTurnstileToken(null),
        appearance: 'always',
        theme: 'dark', // Matched to your dark theme
      });
    };

    if (window.turnstile) mount();
    else {
      let attempts = 0;
      const retry = setInterval(() => {
        attempts += 1;
        if (window.turnstile) { clearInterval(retry); mount(); }
        else if (attempts >= 30) clearInterval(retry);
      }, 200);
      return () => clearInterval(retry);
    }
    return () => { if (widgetId !== null && window.turnstile) { try { window.turnstile.remove(widgetId); } catch(e){} } };
  }, [showModal]);

  // 3. Render Balance Modal Turnstile (Runs when checking balance)
  useEffect(() => {
    if (!showBalanceModal || balanceData || !balanceTurnstileRef.current) return;
    setBalanceTurnstileToken(null);
    let widgetId = null;

    const mount = () => {
      if (!window.turnstile || !balanceTurnstileRef.current) return;
      balanceTurnstileRef.current.innerHTML = '';
      widgetId = window.turnstile.render(balanceTurnstileRef.current, {
        sitekey: TURNSTILE_SITE_KEY,
        callback: (token) => setBalanceTurnstileToken(token),
        'expired-callback': () => setBalanceTurnstileToken(null),
        'error-callback': () => setBalanceTurnstileToken(null),
        appearance: 'always',
        theme: 'dark',
      });
    };

    if (window.turnstile) mount();
    else {
      let attempts = 0;
      const retry = setInterval(() => {
        attempts += 1;
        if (window.turnstile) { clearInterval(retry); mount(); }
        else if (attempts >= 30) clearInterval(retry);
      }, 200);
      return () => clearInterval(retry);
    }
    return () => { if (widgetId !== null && window.turnstile) { try { window.turnstile.remove(widgetId); } catch(e){} } };
  }, [showBalanceModal, balanceData]);

  useEffect(() => {
    if (successData || error || notice) {
      window.requestAnimationFrame(() => window.scrollTo({ top: 0, behavior: 'smooth' }));
    }
  }, [successData, error, notice]);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  };

  const handleInitialSubmit = (e) => {
    e.preventDefault();
    if (!formData.wantQuestions && !formData.wantRemote && !formData.wantPremium && !formData.wantLpunest) return setError("Please select at least one plan feature.");
    setError(null); 
    setNotice(null);
    setApprovalMessage('');
    setShowApprovalModal(false);
    setShowModal(true); // This triggers the Turnstile to load in the modal
  };

  const handleConfirmSubmit = async () => {
    if (!turnstileToken) {
      setError("Please complete the security check first.");
      return;
    }

    setShowModal(false); 
    setLoading(true); 
    setError(null); 
    setNotice(null);
    setApprovalMessage('');
    setShowApprovalModal(false);
    setSuccessData(null);
    
    // Added turnstileToken to payload
    const payload = { 
      ...formData, 
      questions: parseInt(formData.questions, 10) || 0,
      turnstileToken 
    };

    try {
      const response = await fetch(`${API_URL}/api/vendor/activate`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (!response.ok || !data.success) throw new Error(data.message || 'Failed to activate user.');
      
      setSuccessData(data.data);
      if (data.approvalNotice) {
        const message = data.message || 'Your LPUNEST request has been sent for approval. Once approved, it can be used.';
        setNotice(message);
        setApprovalMessage(message);
        setShowApprovalModal(true);
      }
      setFormData(prev => ({
        ...prev, promoCode: '', name: '', email: '', mobile: '', registrationNumber: '',
        wantQuestions: false, questions: 0, wantPremium: false, wantRemote: false, wantLpunest: false,
      }));
    } catch (err) { setError(err.message); } 
    finally { setLoading(false); }
  };

  const fetchBalance = async (e) => {
    if (e) e.preventDefault();
    
    if (!balanceTurnstileToken) {
      setBalanceError("Please complete the security check.");
      return;
    }

    const keyToUse = balanceKey || formData.vendorKey;
    if (!keyToUse) { setBalanceError("Please enter your Master Key."); return; }

    setBalanceLoading(true); setBalanceError(null);

    try {
      const response = await fetch(`${API_URL}/api/vendor/dashboard`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, 
        // Added turnstileToken to payload
        body: JSON.stringify({ vendorKey: keyToUse, turnstileToken: balanceTurnstileToken }),
      });
      const data = await response.json();
      if (!response.ok || !data.success) throw new Error(data.message || 'Failed to fetch balance.');
      
      setBalanceData(data.data);
      setActiveDashboardTab('overview');
      setDashboardSearch('');
      setDashboardStatusFilter('all');
      setDashboardServiceFilter('all');
      setDashboardActionError(null);
      setDashboardActionNotice(null);
    } catch (err) { setBalanceError(err.message); } 
    finally { setBalanceLoading(false); }
  };

  const updateDashboardUser = (updatedUser) => {
    setBalanceData(prev => {
      if (!prev || !Array.isArray(prev.users)) return prev;
      const users = prev.users.map(user => user.id === updatedUser.id ? { ...user, ...updatedUser } : user);
      const usage = buildUsageFromUsers(users, prev.usage || {});
      return {
        ...prev,
        users,
        usage,
        total_api_limit: usage.total_api_limit,
        total_api_used: usage.total_api_used,
      };
    });
  };

  const prependDashboardActivity = (activityLog) => {
    if (!activityLog) return;
    setBalanceData(prev => {
      if (!prev) return prev;
      const currentLogs = Array.isArray(prev.activity_logs) ? prev.activity_logs : [];
      const activityLogs = [activityLog, ...currentLogs.filter(item => item.id !== activityLog.id)].slice(0, 50);
      return {
        ...prev,
        activity_logs: activityLogs,
        usage: {
          ...(prev.usage || {}),
          displayed_activity: activityLogs.length,
        },
      };
    });
  };

  const handleRevokeUser = async () => {
    if (!pendingRevokeUser || dashboardActionLoading) return;

    const keyToUse = balanceKey || formData.vendorKey;
    if (!keyToUse || !balanceData?.management_token) {
      setDashboardActionError('Dashboard session expired. Reopen the vendor dashboard and try again.');
      return;
    }

    setDashboardActionLoading(true);
    setDashboardActionError(null);
    setDashboardActionNotice(null);

    try {
      const response = await fetch(`${API_URL}/api/vendor/users/revoke`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          vendorKey: keyToUse,
          managementToken: balanceData.management_token,
          userId: pendingRevokeUser.id,
          registrationNumber: pendingRevokeUser.registration_number,
        }),
      });
      const data = await response.json();
      if (!response.ok || !data.success) throw new Error(data.message || 'Failed to revoke user access.');

      updateDashboardUser(data.data.user);
      prependDashboardActivity(data.data.activity_log);
      setDashboardActionNotice(data.message || 'User access revoked.');
      setPendingRevokeUser(null);
    } catch (err) {
      setDashboardActionError(err.message);
    } finally {
      setDashboardActionLoading(false);
    }
  };

  const handleReactivateUser = async () => {
    if (!pendingReactivateUser || dashboardActionLoading) return;

    const keyToUse = balanceKey || formData.vendorKey;
    if (!keyToUse || !balanceData?.management_token) {
      setDashboardActionError('Dashboard session expired. Reopen the vendor dashboard and try again.');
      return;
    }

    setDashboardActionLoading(true);
    setDashboardActionError(null);
    setDashboardActionNotice(null);

    try {
      const response = await fetch(`${API_URL}/api/vendor/users/reactivate`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          vendorKey: keyToUse,
          managementToken: balanceData.management_token,
          userId: pendingReactivateUser.id,
          registrationNumber: pendingReactivateUser.registration_number,
        }),
      });
      const data = await response.json();
      if (!response.ok || !data.success) throw new Error(data.message || 'Failed to reactivate user access.');

      updateDashboardUser(data.data.user);
      prependDashboardActivity(data.data.activity_log);
      setDashboardActionNotice(data.message || 'User access reactivated.');
      setPendingReactivateUser(null);
    } catch (err) {
      setDashboardActionError(err.message);
    } finally {
      setDashboardActionLoading(false);
    }
  };

  const prepareExistingUserActivation = (user, mode = 'activate') => {
    const keyToUse = balanceKey || formData.vendorKey;
    const creditAmount = mode === 'credits' ? Math.max(1, Number(formData.questions || 100)) : 0;

    setFormData(prev => ({
      ...prev,
      vendorKey: keyToUse || prev.vendorKey,
      promoCode: '',
      name: user.name || '',
      email: user.email || '',
      mobile: user.mobile || '',
      registrationNumber: user.registration_number || '',
      wantQuestions: mode === 'credits',
      questions: creditAmount,
      wantPremium: false,
      wantRemote: false,
      wantLpunest: false,
    }));
    setNotice(mode === 'credits'
      ? 'Existing user loaded. Adjust the question count and submit to add credits using the normal activation flow.'
      : 'Existing user loaded. Select services and submit to activate this account again.');
    setError(null);
    setSuccessData(null);
    setShowBalanceModal(false);
    setBalanceData(null);
    window.requestAnimationFrame(() => window.scrollTo({ top: 0, behavior: 'smooth' }));
  };

  const openBalanceModal = () => {
    setBalanceData(null); 
    setBalanceError(null); 
    setBalanceKey(formData.vendorKey);
    setActiveDashboardTab('overview');
    setDashboardSearch('');
    setDashboardStatusFilter('all');
    setDashboardServiceFilter('all');
    setDashboardActionError(null);
    setDashboardActionNotice(null);
    setPendingRevokeUser(null);
    setPendingReactivateUser(null);
    setShowBalanceModal(true);
  };

  const vendorUsers = Array.isArray(balanceData?.users) ? balanceData.users : [];
  const vendorHistory = Array.isArray(balanceData?.history) ? balanceData.history : [];
  const vendorActivityLogs = Array.isArray(balanceData?.activity_logs) ? balanceData.activity_logs : [];
  const vendorWalletLedger = Array.isArray(balanceData?.wallet_ledger) ? balanceData.wallet_ledger : [];
  const vendorUsage = balanceData?.usage || {};
  const activatedUsersCount = balanceData?.activated_users_count ?? vendorUsers.length;
  const totalApiLimit = balanceData?.total_api_limit ?? vendorUsage.total_api_limit ?? null;
  const totalApiUsed = balanceData?.total_api_used ?? vendorUsage.total_api_used ?? null;
  const usagePercent = totalApiLimit ? Math.min(100, Math.round((Number(totalApiUsed || 0) / Number(totalApiLimit)) * 100)) : null;
  const activePermissionsCount = [
    balanceData?.can_activate_premium,
    balanceData?.can_activate_remote,
    balanceData?.can_activate_lpunest,
  ].filter(Boolean).length;
  const normalizedDashboardSearch = dashboardSearch.trim().toLowerCase();
  const filteredVendorUsers = vendorUsers.filter(user => {
    const haystack = [
      user.name,
      user.email,
      user.mobile,
      user.registration_number,
      ...(Array.isArray(user.services) ? user.services : getUserServiceLabels(user)),
    ].filter(Boolean).join(' ').toLowerCase();

    const matchesSearch = !normalizedDashboardSearch || haystack.includes(normalizedDashboardSearch);
    const matchesStatus = dashboardStatusFilter === 'all' || user.status === dashboardStatusFilter;
    const matchesService = dashboardServiceFilter === 'all'
      || (dashboardServiceFilter === 'questions' && user.status === 'active' && Number(user.api_limit || 0) > 0)
      || (dashboardServiceFilter === 'premium' && user.premium_status === 'active')
      || (dashboardServiceFilter === 'remote' && user.RDP_status === 'active')
      || (dashboardServiceFilter === 'lpunest' && hasLpunestAccess(user))
      || (dashboardServiceFilter === 'expired_remote' && user.RDP_status === 'active' && user.RDP_expire && new Date(user.RDP_expire) < new Date());

    return matchesSearch && matchesStatus && matchesService;
  });

  return (
    <>
      <VendorPageStyles />
      
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-40 bg-black/80 backdrop-blur-md border-b border-white/5">
        <div className="container mx-auto px-4 py-4 flex justify-between items-center">
            <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-sky-500 to-indigo-600 flex items-center justify-center font-bold text-white">CS</div>
                <h1 className="text-xl font-bold text-white tracking-tight">Vendor <span className="text-sky-500">Portal</span></h1>
            </div>
            
            <button onClick={openBalanceModal} className="flex items-center gap-2 text-sm font-medium text-sky-400 hover:text-white transition-colors bg-gray-900 px-4 py-2 rounded-lg border border-gray-800 hover:border-sky-500/50">
              <Icons.Chart /> Vendor Dashboard
            </button>
        </div>
      </header>

      <main className="min-h-screen pt-28 pb-12 px-4 sm:px-6 lg:px-8 hero-bg">
        <div className="max-w-4xl mx-auto space-y-8 animate-on-load">
          
          <div className="text-center mb-10">
            <h2 className="text-4xl font-bold text-white mb-3">Activate User License</h2>
            <p className="text-gray-400">Provision a new account or upgrade an existing user instantly.</p>
          </div>

          {/* Success Output */}
          {successData && (
            <div className="bg-emerald-950/30 border border-emerald-500/30 rounded-2xl p-6 shadow-2xl animate-visible">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-10 rounded-full bg-emerald-500/20 flex items-center justify-center border border-emerald-500/30">
                  <Icons.Success />
                </div>
                <h3 className="text-xl font-bold text-emerald-400">Activation Successful</h3>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
                <div className="bg-black/50 p-4 rounded-xl border border-white/5">
                  <p className="text-gray-500 text-xs uppercase tracking-wider mb-1">Reg Number</p>
                  <p className="text-white font-mono">{successData.registration_number}</p>
                </div>
                <div className="bg-black/50 p-4 rounded-xl border border-emerald-500/20">
                  <p className="text-emerald-500/70 text-xs uppercase tracking-wider mb-1">Passkey (Remote Auth)</p>
                  <p className="text-emerald-400 font-mono font-bold text-lg">{successData.passkey || 'N/A'}</p>
                </div>
                <div className="bg-black/50 p-4 rounded-xl border border-white/5">
                  <p className="text-gray-500 text-xs uppercase tracking-wider mb-1">API Limit</p>
                  <p className="text-white font-medium">{successData.api_limit} Questions</p>
                </div>
                <div className="bg-black/50 p-4 rounded-xl border border-white/5">
                  <p className="text-gray-500 text-xs uppercase tracking-wider mb-1">RDP Expiry</p>
                  <p className="text-white font-medium">{successData.RDP_expire ? new Date(successData.RDP_expire).toLocaleDateString() : 'N/A'}</p>
                </div>
                <div className="bg-black/50 p-4 rounded-xl border border-white/5">
                  <p className="text-gray-500 text-xs uppercase tracking-wider mb-1">LPUNEST</p>
                  <p className={`font-medium ${successData.lpunest_status === 'active' ? 'text-emerald-400' : successData.lpunest_status === 'approval_pending' ? 'text-amber-400' : 'text-white'}`}>
                    {successData.lpunest_status === 'active' ? 'Active' : successData.lpunest_status === 'approval_pending' ? 'Approval Pending' : 'Not Requested'}
                  </p>
                </div>
              </div>
              <p className="text-sm text-emerald-500/70 mt-6 text-center">Share these exact details securely with the customer.</p>
            </div>
          )}

          {error && (
            <div className="bg-red-950/40 border border-red-500/30 rounded-xl p-4 flex items-center gap-3">
              <div className="text-red-400"><Icons.Alert /></div>
              <p className="text-red-300 text-sm">{error}</p>
            </div>
          )}

          {notice && (
            <div className="bg-amber-950/40 border border-amber-500/30 rounded-xl p-4 flex items-center gap-3">
              <div className="text-amber-400"><Icons.Alert /></div>
              <p className="text-amber-200 text-sm">{notice}</p>
            </div>
          )}

          <div className="bg-amber-950/20 border border-amber-500/20 rounded-xl p-4 flex items-start gap-4">
             <div className="w-8 h-8 rounded-full bg-amber-500/10 flex items-center justify-center flex-shrink-0 border border-amber-500/20 mt-0.5">
                <div className="text-amber-400 w-5 h-5"><Icons.Alert /></div>
             </div>
             <div>
               <h4 className="text-amber-400 font-semibold mb-1">Activation Code Not Required</h4>
               <p className="text-amber-500/70 text-sm leading-relaxed">Enter the Master Key and customer details only. The portal will assign a single-use activation code automatically.</p>
             </div>
          </div>

          <form onSubmit={handleInitialSubmit} className="space-y-6">
            <div className="feature-card p-6 rounded-2xl">
              <h3 className="text-lg font-bold text-white mb-5 flex items-center gap-2"><span className="text-sky-500">1.</span> Vendor Authorization</h3>
              <div className="grid grid-cols-1 gap-5">
                <div>
                  <label className="block text-sm font-medium text-gray-400 mb-2">Master Key *</label>
                  <input required type="password" name="vendorKey" value={formData.vendorKey} onChange={handleInputChange} className="w-full rounded-xl cyber-input px-4 py-3" placeholder="Enter your permanent key" />
                </div>
              </div>
            </div>

            <div className="feature-card p-6 rounded-2xl">
              <h3 className="text-lg font-bold text-white mb-5 flex items-center gap-2"><span className="text-sky-500">2.</span> Customer Information</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                <div>
                  <label className="block text-sm font-medium text-gray-400 mb-2">Full Name</label>
                  <input type="text" name="name" value={formData.name} onChange={handleInputChange} className="w-full rounded-xl cyber-input px-4 py-3" placeholder="John Doe" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-400 mb-2">Email Address *</label>
                  <input required type="email" name="email" value={formData.email} onChange={handleInputChange} className="w-full rounded-xl cyber-input px-4 py-3" placeholder="john@example.com" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-400 mb-2">Mobile Number</label>
                  <input type="text" name="mobile" value={formData.mobile} onChange={handleInputChange} className="w-full rounded-xl cyber-input px-4 py-3" placeholder="+91 9876543210" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-400 mb-2">Registration/Device ID *</label>
                  <input required type="text" name="registrationNumber" value={formData.registrationNumber} onChange={handleInputChange} className="w-full rounded-xl cyber-input px-4 py-3" placeholder="REG-8829" />
                </div>
              </div>
            </div>

            <div className="feature-card p-6 rounded-2xl">
              <h3 className="text-lg font-bold text-white mb-5 flex items-center gap-2"><span className="text-sky-500">3.</span> Plan Configuration</h3>
              <div className="flex flex-wrap gap-4 mb-6">
                <label className={`cursor-pointer px-5 py-3 rounded-xl border transition-all flex items-center gap-3 ${formData.wantQuestions ? 'bg-indigo-500/20 border-indigo-500 text-white' : 'bg-black/30 border-white/10 text-gray-400 hover:border-white/20'}`}>
                  <input type="checkbox" name="wantQuestions" checked={formData.wantQuestions} onChange={handleInputChange} className="hidden" />
                  <div className={`w-4 h-4 rounded border flex items-center justify-center ${formData.wantQuestions ? 'bg-indigo-500 border-indigo-500' : 'border-gray-500'}`}>{formData.wantQuestions && <Icons.Check />}</div>
                  API Questions
                </label>
                <label className={`cursor-pointer px-5 py-3 rounded-xl border transition-all flex items-center gap-3 ${formData.wantPremium ? 'bg-violet-500/20 border-violet-500 text-white' : 'bg-black/30 border-white/10 text-gray-400 hover:border-white/20'}`}>
                  <input type="checkbox" name="wantPremium" checked={formData.wantPremium} onChange={handleInputChange} className="hidden" />
                  <div className={`w-4 h-4 rounded border flex items-center justify-center ${formData.wantPremium ? 'bg-violet-500 border-violet-500' : 'border-gray-500'}`}>{formData.wantPremium && <Icons.Check />}</div>
                  Premium Status
                </label>
                <label className={`cursor-pointer px-5 py-3 rounded-xl border transition-all flex items-center gap-3 ${formData.wantRemote ? 'bg-cyan-500/20 border-cyan-500 text-white' : 'bg-black/30 border-white/10 text-gray-400 hover:border-white/20'}`}>
                  <input type="checkbox" name="wantRemote" checked={formData.wantRemote} onChange={handleInputChange} className="hidden" />
                  <div className={`w-4 h-4 rounded border flex items-center justify-center ${formData.wantRemote ? 'bg-cyan-500 border-cyan-500' : 'border-gray-500'}`}>{formData.wantRemote && <Icons.Check />}</div>
                  RDP Access
                </label>
                <label className={`cursor-pointer px-5 py-3 rounded-xl border transition-all flex items-center gap-3 ${formData.wantLpunest ? 'bg-emerald-500/20 border-emerald-500 text-white' : 'bg-black/30 border-white/10 text-gray-400 hover:border-white/20'}`}>
                  <input type="checkbox" name="wantLpunest" checked={formData.wantLpunest} onChange={handleInputChange} className="hidden" />
                  <div className={`w-4 h-4 rounded border flex items-center justify-center ${formData.wantLpunest ? 'bg-emerald-500 border-emerald-500' : 'border-gray-500'}`}>{formData.wantLpunest && <Icons.Check />}</div>
                  LPUNEST
                </label>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-5 bg-black/40 p-5 rounded-xl border border-white/5">
                <div className={`transition-opacity duration-200 ${formData.wantQuestions ? 'opacity-100' : 'opacity-30 pointer-events-none'}`}>
                  <label className="block text-sm font-medium text-gray-400 mb-2">No. of Questions</label>
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-500"><Icons.Terminal /></div>
                    <input type="number" name="questions" min="0" value={formData.questions} onChange={handleInputChange} className="w-full rounded-xl cyber-input pl-10 pr-4 py-2.5" />
                  </div>
                </div>
                <div className={`transition-opacity duration-200 ${formData.wantRemote ? 'opacity-100' : 'opacity-30 pointer-events-none'}`}>
                  <label className="block text-sm font-medium text-gray-400 mb-2">Remote Duration</label>
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-500"><Icons.Monitor /></div>
                    <select name="remoteDuration" value={formData.remoteDuration} onChange={handleInputChange} className="w-full rounded-xl cyber-input pl-10 pr-4 py-2.5 appearance-none">
                      <option value="1h">1 Hour</option>
                      <option value="2h">2 Hours</option>
                      <option value="4h">4 Hours</option>
                      <option value="8h">8 Hours</option>
                      <option value="1d">1 Day</option>
                      <option value="3d">3 Days</option>
                      <option value="7d">7 Days</option>
                    </select>
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-400 mb-2">Promo Code <span className="text-gray-600">(Opt)</span></label>
                  <input type="text" name="promoCode" value={formData.promoCode} onChange={handleInputChange} className="w-full rounded-xl cyber-input px-4 py-2.5 uppercase" placeholder="e.g. WELCOME10" />
                </div>
              </div>
            </div>

            <div className="pt-4">
              <button type="submit" disabled={loading} className="w-full btn-primary text-white font-bold text-lg py-4 rounded-2xl flex items-center justify-center gap-3 tracking-wide">
                {loading ? <span className="animate-pulse">Loading Security Check...</span> : 'Review & Activate User'}
              </button>
            </div>
          </form>
        </div>
      </main>

      {/* --- ACTIVATION CONFIRMATION MODAL --- */}
      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center px-4 modal-backdrop animate-fadeIn" onClick={() => setShowModal(false)}>
          <div className="modal-content rounded-3xl max-w-lg w-full p-8 relative overflow-hidden" onClick={e => e.stopPropagation()}>
            <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-sky-500 to-indigo-500"></div>
            <h3 className="text-2xl font-bold text-white mb-2">Confirm Deduction</h3>
            <p className="text-gray-400 text-sm mb-6">Review the inventory deduction for activating <strong>{formData.email}</strong>.</p>
            
            <div className="bg-black/50 border border-white/5 rounded-xl p-5 space-y-4 mb-6">
              {formData.wantQuestions && (
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2 text-gray-300"><span className="text-indigo-400"><Icons.Terminal /></span> API Questions</div>
                  <span className="text-sky-400 font-mono font-bold">-{formData.questions} credits</span>
                </div>
              )}
              {formData.wantPremium && (
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2 text-gray-300"><span className="text-violet-400"><Icons.Zap /></span> Premium Status</div>
                  <span className="text-violet-400 font-mono font-bold">-1 pass</span>
                </div>
              )}
              {formData.wantRemote && (
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2 text-gray-300"><span className="text-cyan-400"><Icons.Monitor /></span> RDP Access ({formData.remoteDuration})</div>
                  <span className="text-cyan-400 font-mono font-bold">-{formData.remoteDuration.replace('h', ' hours').replace('d', ' days')}</span>
                </div>
              )}
              {formData.wantLpunest && (
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2 text-gray-300"><span className="text-emerald-400"><Icons.Check /></span> LPUNEST Access</div>
                  <span className="text-emerald-400 font-mono font-bold">permission check</span>
                </div>
              )}
            </div>

            {/* SECURITY CHECK RENDERED HERE */}
            <div className="flex justify-center mb-6">
               <div ref={turnstileRef} />
            </div>

            <div className="flex gap-3">
              <button onClick={() => setShowModal(false)} className="flex-1 py-3 rounded-xl font-medium text-gray-400 bg-white/5 hover:bg-white/10 transition-colors">Cancel</button>
              <button onClick={handleConfirmSubmit} disabled={!turnstileToken || loading} className="flex-1 py-3 rounded-xl font-bold text-white btn-primary shadow-lg shadow-indigo-500/20 disabled:opacity-50">
                {loading ? 'Processing...' : 'Authorize & Activate'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* --- LPUNEST APPROVAL NOTICE MODAL --- */}
      {showApprovalModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center px-4 modal-backdrop animate-fadeIn" onClick={() => setShowApprovalModal(false)}>
          <div className="modal-content rounded-3xl max-w-md w-full p-8 relative overflow-hidden" onClick={e => e.stopPropagation()}>
            <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-amber-500 to-emerald-500"></div>
            
            <div className="flex items-start gap-4 mb-6">
              <div className="w-12 h-12 rounded-full bg-amber-500/10 border border-amber-500/30 flex items-center justify-center text-amber-400 flex-shrink-0">
                <Icons.Alert />
              </div>
              <div>
                <h3 className="text-2xl font-bold text-white leading-tight">LPUNEST Approval Sent</h3>
                <p className="text-amber-300 text-sm font-medium mt-1">Approval pending</p>
              </div>
            </div>

            <p className="text-gray-300 text-sm leading-relaxed mb-5">
              {approvalMessage}
            </p>

            <div className="bg-black/50 border border-white/5 rounded-xl p-4 space-y-3 mb-6">
              <div className="flex justify-between gap-3">
                <span className="text-gray-500 text-xs uppercase tracking-wider">Device ID</span>
                <span className="text-white font-mono text-sm text-right break-all">{successData?.registration_number || 'N/A'}</span>
              </div>
              <div className="flex justify-between gap-3">
                <span className="text-gray-500 text-xs uppercase tracking-wider">Activation</span>
                <span className="text-emerald-400 font-semibold text-sm text-right">Completed normally</span>
              </div>
              <div className="flex justify-between gap-3">
                <span className="text-gray-500 text-xs uppercase tracking-wider">LPUNEST</span>
                <span className="text-amber-400 font-semibold text-sm text-right">Waiting for admin approval</span>
              </div>
            </div>

            <button onClick={() => setShowApprovalModal(false)} className="w-full py-3 rounded-xl font-bold text-white btn-primary">
              Got it
            </button>
          </div>
        </div>
      )}

      {/* --- VENDOR DASHBOARD MODAL --- */}
      {showBalanceModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center px-4 modal-backdrop animate-fadeIn" onClick={() => setShowBalanceModal(false)}>
          <div className="modal-content rounded-3xl max-w-6xl w-full max-h-[90vh] overflow-y-auto p-6 sm:p-8 relative" onClick={e => e.stopPropagation()}>
            <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-sky-500 via-indigo-500 to-emerald-500"></div>

            <div className="flex justify-between items-start gap-4 mb-6">
              <div>
                <h3 className="text-2xl font-bold text-white">Vendor Dashboard</h3>
                <p className="text-gray-400 text-sm">Wallet, permissions, users, usage, and activation history.</p>
              </div>
              <button onClick={() => setShowBalanceModal(false)} className="text-gray-500 hover:text-white transition-colors text-xl">&times;</button>
            </div>

            {!balanceData ? (
              <form onSubmit={fetchBalance} className="space-y-6 max-w-xl mx-auto">
                <div>
                  <label className="block text-sm font-medium text-gray-400 mb-2">Enter Master Key</label>
                  <input type="password" value={balanceKey} onChange={e => setBalanceKey(e.target.value)} className="w-full rounded-xl cyber-input px-4 py-3" placeholder="Your permanent key" required />
                </div>

                <div className="flex justify-center">
                  <div ref={balanceTurnstileRef} />
                </div>

                {balanceError && <p className="text-red-400 text-sm text-center">{balanceError}</p>}

                <button type="submit" disabled={balanceLoading || !balanceTurnstileToken} className="w-full py-3 rounded-xl font-bold text-white bg-gray-800 hover:bg-gray-700 transition-colors border border-gray-600 disabled:opacity-50 disabled:cursor-not-allowed">
                  {balanceLoading ? 'Opening Dashboard...' : 'Open Dashboard'}
                </button>
              </form>
            ) : (
              <div className="space-y-6 animate-fadeIn">
                <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4 p-4 bg-white/5 rounded-2xl border border-white/10">
                  <div className="flex items-center gap-3">
                    <div className="w-11 h-11 rounded-xl bg-gray-800 flex items-center justify-center text-white font-bold">{(balanceData.name || 'V').charAt(0).toUpperCase()}</div>
                    <div>
                      <p className="text-white font-semibold leading-tight">{balanceData.name || 'Vendor'}</p>
                      <p className="text-gray-500 text-xs">{balanceData.email || 'No email returned'}</p>
                    </div>
                  </div>
                  <div className="flex flex-wrap items-center gap-2">
                    <span className={`text-[10px] px-2.5 py-1 rounded-md border font-bold uppercase tracking-wider ${balanceData.active ? 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20' : 'bg-red-500/10 text-red-400 border-red-500/20'}`}>{balanceData.active ? 'Active Account' : 'Account Locked'}</span>
                    <span className="text-[10px] px-2.5 py-1 rounded-md border font-bold uppercase tracking-wider bg-sky-500/10 text-sky-400 border-sky-500/20">{activePermissionsCount}/3 permissions</span>
                  </div>
                </div>

                <div className="flex gap-2 overflow-x-auto pb-1">
                  {DASHBOARD_TABS.map(tab => {
                    const Icon = tab.icon;
                    const isActive = activeDashboardTab === tab.id;
                    return (
                      <button key={tab.id} type="button" onClick={() => setActiveDashboardTab(tab.id)} className={`flex items-center gap-2 px-4 py-2 rounded-xl border text-sm font-medium whitespace-nowrap transition-all ${isActive ? 'bg-sky-500/15 border-sky-500/40 text-white' : 'bg-black/30 border-white/10 text-gray-400 hover:text-white hover:border-white/20'}`}>
                        <Icon /> {tab.label}
                      </button>
                    );
                  })}
                </div>

                {dashboardActionError && (
                  <div className="rounded-xl border border-red-500/30 bg-red-950/30 px-4 py-3 text-sm text-red-300 flex items-center gap-3">
                    <span className="text-red-400"><Icons.Alert /></span>
                    {dashboardActionError}
                  </div>
                )}

                {dashboardActionNotice && (
                  <div className="rounded-xl border border-emerald-500/30 bg-emerald-950/30 px-4 py-3 text-sm text-emerald-300 flex items-center gap-3">
                    <span className="text-emerald-400"><Icons.Success /></span>
                    {dashboardActionNotice}
                  </div>
                )}

                {activeDashboardTab === 'overview' && (
                  <div className="space-y-5">
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                      <StatCard label="Users Activated" value={activatedUsersCount || 0} hint="Linked from activation codes used by this vendor." tone="sky" />
                      <StatCard label="API Used" value={totalApiUsed !== null && totalApiLimit !== null ? `${totalApiUsed}/${totalApiLimit}` : 'N/A'} hint={usagePercent !== null ? `${usagePercent}% consumed by activated users.` : 'Needs usage endpoint.'} tone="indigo" />
                      <StatCard label="Question Credits" value={balanceData.wallet_questions ?? 0} hint="Remaining vendor wallet question inventory." tone="violet" />
                      <StatCard label="RDP Stock" value={`${balanceData.wallet_rdp_hours ?? 0}h`} hint={`${(((balanceData.wallet_rdp_hours || 0) / 24).toFixed(1))} days available.`} tone="cyan" />
                    </div>
                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
                      <div className="lg:col-span-2 rounded-2xl border border-white/10 bg-white/[0.03] p-5">
                        <h4 className="text-white font-semibold mb-4">Operational Snapshot</h4>
                        <div className="space-y-3">
                          <PermissionRow label="Premium activation" enabled={balanceData.can_activate_premium} detail="Allows selling premium passes." />
                          <PermissionRow label="Remote access activation" enabled={balanceData.can_activate_remote} detail="Allows allocating RDP hours." />
                          <PermissionRow label="LPUNEST direct approval" enabled={balanceData.can_activate_lpunest} detail="Allows clearing LPUNEST restriction immediately." />
                        </div>
                      </div>
                      <div className="rounded-2xl border border-emerald-500/20 bg-emerald-950/10 p-5">
                        <div className="text-emerald-400 mb-3"><Icons.History /></div>
                        <h4 className="text-white font-semibold mb-4">Activation Pulse</h4>
                        <div className="space-y-3 text-sm">
                          <div className="flex justify-between gap-3"><span className="text-gray-400">Today</span><span className="text-white font-mono">{vendorUsage.activations_today ?? 0}</span></div>
                          <div className="flex justify-between gap-3"><span className="text-gray-400">This month</span><span className="text-white font-mono">{vendorUsage.activations_this_month ?? 0}</span></div>
                          <div className="flex justify-between gap-3"><span className="text-gray-400">Suspends today</span><span className="text-white font-mono">{vendorUsage.suspensions_today ?? 0}</span></div>
                          <div className="flex justify-between gap-3"><span className="text-gray-400">Reactivations today</span><span className="text-white font-mono">{vendorUsage.reactivations_today ?? 0}</span></div>
                          <div className="flex justify-between gap-3"><span className="text-gray-400">Premium users</span><span className="text-white font-mono">{vendorUsage.premium_users ?? 0}</span></div>
                          <div className="flex justify-between gap-3"><span className="text-gray-400">Remote users</span><span className="text-white font-mono">{vendorUsage.remote_users ?? 0}</span></div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {activeDashboardTab === 'users' && (
                  vendorUsers.length ? (
                    <div className="space-y-4">
                      <div className="rounded-2xl border border-white/10 bg-white/[0.03] p-4">
                        <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
                          <div className="md:col-span-2">
                            <label className="block text-[10px] uppercase tracking-wider text-gray-500 font-bold mb-2">Search users</label>
                            <input value={dashboardSearch} onChange={e => setDashboardSearch(e.target.value)} className="w-full rounded-xl cyber-input px-4 py-2.5" placeholder="Name, email, mobile, device, service" />
                          </div>
                          <div>
                            <label className="block text-[10px] uppercase tracking-wider text-gray-500 font-bold mb-2">Status</label>
                            <select value={dashboardStatusFilter} onChange={e => setDashboardStatusFilter(e.target.value)} className="w-full rounded-xl cyber-input px-4 py-2.5">
                              <option value="all">All users</option>
                              <option value="active">Active only</option>
                              <option value="inactive">Inactive only</option>
                            </select>
                          </div>
                          <div>
                            <label className="block text-[10px] uppercase tracking-wider text-gray-500 font-bold mb-2">Service</label>
                            <select value={dashboardServiceFilter} onChange={e => setDashboardServiceFilter(e.target.value)} className="w-full rounded-xl cyber-input px-4 py-2.5">
                              <option value="all">All services</option>
                              <option value="questions">Questions</option>
                              <option value="premium">Premium</option>
                              <option value="remote">RDP active</option>
                              <option value="expired_remote">RDP expired</option>
                              <option value="lpunest">LPUNEST</option>
                            </select>
                          </div>
                        </div>
                        <div className="flex items-center justify-between gap-3 mt-4 text-xs text-gray-500">
                          <span>Showing {filteredVendorUsers.length} of {vendorUsers.length} vendor users</span>
                          {(dashboardSearch || dashboardStatusFilter !== 'all' || dashboardServiceFilter !== 'all') && (
                            <button type="button" onClick={() => { setDashboardSearch(''); setDashboardStatusFilter('all'); setDashboardServiceFilter('all'); }} className="text-sky-400 hover:text-white">
                              Clear filters
                            </button>
                          )}
                        </div>
                      </div>

                      {filteredVendorUsers.length ? (
                        <div className="overflow-hidden rounded-2xl border border-white/10">
                          <div className="grid grid-cols-5 gap-3 bg-white/5 px-4 py-3 text-[10px] uppercase tracking-wider text-gray-500 font-bold">
                            <span>User</span><span>Device</span><span>API</span><span>Access</span><span className="text-right">Action</span>
                          </div>
                          {filteredVendorUsers.map((user, index) => {
                            const services = getUserServiceLabels(user);
                            const recoverableServices = getRecoverableServiceLabels(user);
                            const canRevoke = hasAnyLiveAccess(user);
                            const canReactivate = !canRevoke && recoverableServices.length > 0;
                            return (
                              <div key={user.id || user.registration_number || index} className="grid grid-cols-5 gap-3 px-4 py-3 border-t border-white/5 text-sm items-center">
                                <span className="text-white truncate">
                                  {user.name || 'Unnamed'}
                                  <span className="block text-xs text-gray-500 truncate">{user.email || 'No email'}</span>
                                </span>
                                <span className="text-gray-400 font-mono truncate">{user.registration_number || 'N/A'}</span>
                                <span className="text-sky-400 font-mono">{user.api_used ?? 0}/{user.api_limit ?? 0}</span>
                                <span>
                                  <span className={user.status === 'active' ? 'text-emerald-400' : 'text-red-400'}>{user.status || 'unknown'}</span>
                                  <span className="block text-xs text-gray-500 truncate">{services.length ? services.join(', ') : recoverableServices.length ? `Suspended: ${recoverableServices.join(', ')}` : 'Needs activation'}</span>
                                </span>
                                <span className="flex justify-end gap-2">
                                  <button type="button" disabled={dashboardActionLoading} onClick={() => prepareExistingUserActivation(user, 'credits')} className="px-3 py-1.5 rounded-lg border border-sky-500/30 bg-sky-500/10 text-sky-300 hover:bg-sky-500/20 hover:text-white text-xs font-semibold transition-colors">
                                    Add credits
                                  </button>
                                  {canRevoke ? (
                                    <button type="button" disabled={dashboardActionLoading} onClick={() => setPendingRevokeUser(user)} className="px-3 py-1.5 rounded-lg border border-red-500/30 bg-red-500/10 text-red-300 hover:bg-red-500/20 hover:text-white text-xs font-semibold transition-colors disabled:opacity-50">
                                      Suspend
                                    </button>
                                  ) : canReactivate ? (
                                    <button type="button" disabled={dashboardActionLoading} onClick={() => setPendingReactivateUser(user)} className="px-3 py-1.5 rounded-lg border border-emerald-500/30 bg-emerald-500/10 text-emerald-300 hover:bg-emerald-500/20 hover:text-white text-xs font-semibold transition-colors disabled:opacity-50">
                                      Reactivate
                                    </button>
                                  ) : (
                                    <button type="button" disabled={dashboardActionLoading} onClick={() => prepareExistingUserActivation(user, 'activate')} className="px-3 py-1.5 rounded-lg border border-amber-500/30 bg-amber-500/10 text-amber-300 hover:bg-amber-500/20 hover:text-white text-xs font-semibold transition-colors disabled:opacity-50">
                                      Activate
                                    </button>
                                  )}
                                </span>
                              </div>
                            );
                          })}
                        </div>
                      ) : (
                        <EmptyDashboardState icon={Icons.Users} title="No users match filters" body="Try a different search, status, or service filter." />
                      )}
                    </div>
                  ) : <EmptyDashboardState icon={Icons.Users} title="No activated users yet" body="Users will appear here after this vendor consumes activation codes for customer accounts." />
                )}

                {activeDashboardTab === 'usage' && (
                  totalApiUsed !== null || totalApiLimit !== null ? (
                    <div className="space-y-4">
                      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                        <StatCard label="Total Calls" value={totalApiUsed ?? 0} tone="sky" />
                        <StatCard label="Allocated Limit" value={totalApiLimit ?? 0} tone="indigo" />
                        <StatCard label="Consumption" value={usagePercent !== null ? `${usagePercent}%` : 'N/A'} tone={usagePercent > 85 ? 'amber' : 'emerald'} />
                      </div>
                      <div className="rounded-2xl border border-white/10 bg-white/[0.03] p-5">
                        <div className="h-3 bg-black/50 rounded-full overflow-hidden border border-white/10">
                          <div className="h-full bg-gradient-to-r from-sky-500 to-emerald-500" style={{ width: `${usagePercent || 0}%` }} />
                        </div>
                      </div>
                    </div>
                  ) : <EmptyDashboardState icon={Icons.Terminal} title="No API usage yet" body="API totals appear here after activated users receive question limits or consume calls." />
                )}

                {activeDashboardTab === 'wallet' && (
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <StatCard label="Question Credits Left" value={balanceData.wallet_questions ?? 0} hint="1 credit equals 1 API question limit granted to a user." tone="indigo" />
                    <StatCard label="Premium Passes Left" value={balanceData.wallet_premium ?? 0} hint={balanceData.can_activate_premium ? 'Premium activation is enabled.' : 'Premium activation is revoked by admin.'} tone={balanceData.can_activate_premium ? 'violet' : 'red'} />
                    <StatCard label="LPUNEST Permission" value={balanceData.can_activate_lpunest ? 'ON' : 'OFF'} hint={balanceData.can_activate_lpunest ? 'Can approve LPUNEST instantly.' : 'Requests require admin approval.'} tone={balanceData.can_activate_lpunest ? 'emerald' : 'amber'} />
                    <StatCard label="RDP Hours Left" value={`${balanceData.wallet_rdp_hours ?? 0}h`} hint={balanceData.can_activate_remote ? 'Remote activation is enabled.' : 'Remote activation is revoked by admin.'} tone={balanceData.can_activate_remote ? 'cyan' : 'red'} />
                  </div>
                )}

                {activeDashboardTab === 'ledger' && (
                  vendorWalletLedger.length ? (
                    <div className="space-y-3">
                      {vendorWalletLedger.map((item, index) => (
                        <div key={item.id || index} className="rounded-xl border border-white/10 bg-white/[0.03] p-4">
                          <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-3">
                            <div>
                              <div className="flex flex-wrap items-center gap-2 mb-2">
                                <span className={`text-[10px] px-2.5 py-1 rounded-md border font-bold uppercase tracking-wider ${item.type === 'DEBIT' ? 'bg-amber-500/10 text-amber-300 border-amber-500/25' : 'bg-emerald-500/10 text-emerald-300 border-emerald-500/25'}`}>{item.type || 'Ledger'}</span>
                                <span className="text-white font-semibold">{item.reason || 'Wallet movement'}</span>
                              </div>
                              <p className="text-xs text-gray-500">{item.user?.registration_number || item.metadata?.registration_number || item.user?.email || item.metadata?.email || 'No user linked'}</p>
                            </div>
                            <span className="text-xs text-gray-500 whitespace-nowrap">{formatDashboardDate(item.created_at)}</span>
                          </div>
                          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mt-4 text-sm">
                            <div className="rounded-lg border border-white/5 bg-black/30 px-3 py-2">
                              <span className="block text-[10px] uppercase tracking-wider text-gray-500 mb-1">Questions</span>
                              <span className="text-sky-300 font-mono">{formatLedgerDelta(item.questions_delta)}</span>
                              <span className="text-gray-500 ml-2">bal {item.questions_balance ?? 'N/A'}</span>
                            </div>
                            <div className="rounded-lg border border-white/5 bg-black/30 px-3 py-2">
                              <span className="block text-[10px] uppercase tracking-wider text-gray-500 mb-1">Premium</span>
                              <span className="text-violet-300 font-mono">{formatLedgerDelta(item.premium_delta)}</span>
                              <span className="text-gray-500 ml-2">bal {item.premium_balance ?? 'N/A'}</span>
                            </div>
                            <div className="rounded-lg border border-white/5 bg-black/30 px-3 py-2">
                              <span className="block text-[10px] uppercase tracking-wider text-gray-500 mb-1">RDP Hours</span>
                              <span className="text-cyan-300 font-mono">{formatLedgerDelta(item.rdp_hours_delta, 'h')}</span>
                              <span className="text-gray-500 ml-2">bal {item.rdp_hours_balance ?? 'N/A'}h</span>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : <EmptyDashboardState icon={Icons.Wallet} title="No wallet ledger yet" body="Wallet debits will appear here after this vendor activates or tops up users." />
                )}

                {activeDashboardTab === 'activity' && (
                  vendorActivityLogs.length ? (
                    <div className="space-y-3">
                      {vendorActivityLogs.map((item, index) => (
                        <div key={item.id || index} className="rounded-xl border border-white/10 bg-white/[0.03] p-4 flex flex-col md:flex-row md:items-start md:justify-between gap-4">
                          <div className="min-w-0">
                            <div className="flex flex-wrap items-center gap-2 mb-2">
                              <span className={`text-[10px] px-2.5 py-1 rounded-md border font-bold uppercase tracking-wider ${getActionTone(item.action)}`}>
                                {ACTION_LABELS[item.action] || item.action || 'Audit'}
                              </span>
                              <span className="text-white font-semibold truncate">{item.summary || 'Vendor activity'}</span>
                            </div>
                            <p className="text-xs text-gray-500 truncate">{item.user?.registration_number || item.registration_number || item.user?.email || item.email || 'No user linked'}</p>
                            {item.metadata?.requested_services && <p className="text-xs text-gray-400 mt-2 truncate">Services: {item.metadata.requested_services}</p>}
                            {Array.isArray(item.metadata?.services_suspended) && <p className="text-xs text-gray-400 mt-2 truncate">Suspended: {item.metadata.services_suspended.map(service => SERVICE_LABELS[service] || service).join(', ')}</p>}
                            {Array.isArray(item.metadata?.services_restored) && <p className="text-xs text-gray-400 mt-2 truncate">Restored: {item.metadata.services_restored.map(service => SERVICE_LABELS[service] || service).join(', ')}</p>}
                          </div>
                          <span className="text-xs text-gray-500 whitespace-nowrap">{formatDashboardDate(item.created_at)}</span>
                        </div>
                      ))}
                    </div>
                  ) : <EmptyDashboardState icon={Icons.Shield} title="No audit events yet" body="Suspends, reactivations, activations, and Telegram commands will appear here after the new audit table starts collecting events." />
                )}

                {activeDashboardTab === 'history' && (
                  vendorHistory.length ? (
                    <div className="space-y-3">
                      {vendorHistory.map((item, index) => (
                        <div key={item.id || index} className="rounded-xl border border-white/10 bg-white/[0.03] p-4 flex items-center justify-between gap-4">
                          <div>
                            <p className="text-white font-medium">{item.title || item.used_for || 'Activation'}</p>
                            <p className="text-xs text-gray-500">{item.used_email || item.email || item.description || 'No details returned'}</p>
                          </div>
                          <span className="text-xs text-gray-500">{item.used_at ? new Date(item.used_at).toLocaleString() : item.created_at ? new Date(item.created_at).toLocaleString() : 'N/A'}</span>
                        </div>
                      ))}
                    </div>
                  ) : <EmptyDashboardState icon={Icons.History} title="No activation history yet" body="Activation events will appear here once this vendor starts activating users." />
                )}

                <button onClick={() => { setShowBalanceModal(false); setBalanceData(null); }} className="w-full py-3 rounded-xl font-medium text-gray-400 hover:text-white bg-white/5 hover:bg-white/10 transition-colors mt-2">
                  Close Dashboard
                </button>
              </div>
            )}
          </div>
        </div>
      )}

      {pendingRevokeUser && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center px-4 modal-backdrop animate-fadeIn" onClick={() => !dashboardActionLoading && setPendingRevokeUser(null)}>
          <div className="modal-content rounded-3xl max-w-md w-full p-7 relative overflow-hidden" onClick={e => e.stopPropagation()}>
            <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-red-500 to-amber-500"></div>
            <div className="flex items-start gap-4 mb-5">
              <div className="w-11 h-11 rounded-xl bg-red-500/10 border border-red-500/30 flex items-center justify-center text-red-300 flex-shrink-0">
                <Icons.Alert />
              </div>
              <div>
                <h3 className="text-xl font-bold text-white">Suspend User Access</h3>
                <p className="text-sm text-gray-400 mt-1">This is a soft revoke. The row stays in the database.</p>
              </div>
            </div>

            <div className="rounded-xl border border-white/10 bg-black/40 p-4 space-y-3 mb-5 text-sm">
              <div className="flex justify-between gap-4">
                <span className="text-gray-500">User</span>
                <span className="text-white text-right truncate">{pendingRevokeUser.name || pendingRevokeUser.email || 'Unnamed'}</span>
              </div>
              <div className="flex justify-between gap-4">
                <span className="text-gray-500">Device</span>
                <span className="text-white font-mono text-right truncate">{pendingRevokeUser.registration_number || 'N/A'}</span>
              </div>
              <div className="flex justify-between gap-4">
                <span className="text-gray-500">Current access</span>
                <span className="text-red-200 text-right">{getUserServiceLabels(pendingRevokeUser).join(', ') || 'No live services'}</span>
              </div>
            </div>

            <p className="text-sm text-gray-400 leading-relaxed mb-6">
              Suspending will set question access, premium, RDP, and LPUNEST access inactive for this user and clear backend caches so the change is detected quickly.
            </p>

            <div className="flex gap-3">
              <button type="button" disabled={dashboardActionLoading} onClick={() => setPendingRevokeUser(null)} className="flex-1 py-3 rounded-xl font-medium text-gray-400 bg-white/5 hover:bg-white/10 transition-colors disabled:opacity-50">
                Cancel
              </button>
              <button type="button" disabled={dashboardActionLoading} onClick={handleRevokeUser} className="flex-1 py-3 rounded-xl font-bold text-white bg-red-600 hover:bg-red-500 transition-colors disabled:opacity-50">
                {dashboardActionLoading ? 'Suspending...' : 'Suspend'}
              </button>
            </div>
          </div>
        </div>
      )}

      {pendingReactivateUser && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center px-4 modal-backdrop animate-fadeIn" onClick={() => !dashboardActionLoading && setPendingReactivateUser(null)}>
          <div className="modal-content rounded-3xl max-w-md w-full p-7 relative overflow-hidden" onClick={e => e.stopPropagation()}>
            <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-emerald-500 to-sky-500"></div>
            <div className="flex items-start gap-4 mb-5">
              <div className="w-11 h-11 rounded-xl bg-emerald-500/10 border border-emerald-500/30 flex items-center justify-center text-emerald-300 flex-shrink-0">
                <Icons.Success />
              </div>
              <div>
                <h3 className="text-xl font-bold text-white">Reactivate User Access</h3>
                <p className="text-sm text-gray-400 mt-1">Restore only the services saved when this user was suspended.</p>
              </div>
            </div>

            <div className="rounded-xl border border-white/10 bg-black/40 p-4 space-y-3 mb-5 text-sm">
              <div className="flex justify-between gap-4">
                <span className="text-gray-500">User</span>
                <span className="text-white text-right truncate">{pendingReactivateUser.name || pendingReactivateUser.email || 'Unnamed'}</span>
              </div>
              <div className="flex justify-between gap-4">
                <span className="text-gray-500">Device</span>
                <span className="text-white font-mono text-right truncate">{pendingReactivateUser.registration_number || 'N/A'}</span>
              </div>
              <div className="flex justify-between gap-4">
                <span className="text-gray-500">Restore</span>
                <span className="text-emerald-200 text-right">{getRecoverableServiceLabels(pendingReactivateUser).join(', ') || 'No saved services'}</span>
              </div>
            </div>

            <p className="text-sm text-gray-400 leading-relaxed mb-6">
              This will make the account active again and turn back on the services captured during suspend. It will not add new question credits or change wallet balances.
            </p>

            <div className="flex gap-3">
              <button type="button" disabled={dashboardActionLoading} onClick={() => setPendingReactivateUser(null)} className="flex-1 py-3 rounded-xl font-medium text-gray-400 bg-white/5 hover:bg-white/10 transition-colors disabled:opacity-50">
                Cancel
              </button>
              <button type="button" disabled={dashboardActionLoading} onClick={handleReactivateUser} className="flex-1 py-3 rounded-xl font-bold text-white bg-emerald-600 hover:bg-emerald-500 transition-colors disabled:opacity-50">
                {dashboardActionLoading ? 'Reactivating...' : 'Reactivate'}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default VendorActivateUser;
